import React from "react";
import {useFormContext} from "react-hook-form";
import {DateField} from "src/packages/react-hook-form-mui";

export default function FormDateField({name, ...props}) {
  const {register, formState: {errors, isSubmitting}} = useFormContext();

  return (
    <DateField
      name={name}
      register={register}
      errors={errors}
      disabled={isSubmitting}
      {...props}
    />
  );
}
